import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pra-not-authorized',
  templateUrl: './pra-not-authorized.component.html',
  styleUrls: ['./pra-not-authorized.component.css']
})
export class PraNotAuthorizedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
